import DeleteContent from '@/components/Common/DeleteContent';

export default {
    methods: {
        confirmDelete({
            message,
            value,
            cb: confirmCb = R.identity,
            confirmText,
        } = {}) {
            confirmText = confirmText || this.$t('COMMON.delete');

            return this.dialog({
                child: <DeleteContent message={message} value={value} />,
                confirmType: 'danger',
                confirmText,
                confirmCb,
            });
        },
    },
};
